import { atom } from "recoil";

export const modulIdForPruefungsCreate = atom({
  key: "modulIdForPruefungsCreate", // unique ID (with respect to other atoms/selectors)
  default: 0, // default value (aka initial value)
});
